import React, { useState, useRef, useCallback, useEffect } from 'react';
import useVideoStore from './stores/useVideoStore';
import { searchTags } from './api';
import { useTranslations } from '../ArticleFormNew/contexts/TranslationContext';

export default function VideoTagsInput({ scheduleAutosave }) {
  var t = useTranslations();
  var tagList = useVideoStore(function(s) { return s.tag_list; });
  var updateField = useVideoStore(function(s) { return s.updateField; });

  var queryState = useState('');
  var query = queryState[0];
  var setQuery = queryState[1];

  var suggestionsState = useState([]);
  var suggestions = suggestionsState[0];
  var setSuggestions = suggestionsState[1];

  var openState = useState(false);
  var isOpen = openState[0];
  var setIsOpen = openState[1];

  var debounceRef = useRef(null);
  var containerRef = useRef(null);

  var performSearch = useCallback(function(searchQuery) {
    searchTags(searchQuery || '', 'tags')
      .then(function(names) {
        var filtered = names.filter(function(name) { return !tagList.includes(name); });
        setSuggestions(filtered);
        setIsOpen(filtered.length > 0);
      })
      .catch(function() {
        setSuggestions([]);
      });
  }, [tagList]);

  var handleInputChange = useCallback(function(e) {
    var value = e.target.value;
    setQuery(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(function() { performSearch(value); }, 300);
  }, [performSearch]);

  var handleFocus = useCallback(function() {
    if (suggestions.length === 0 && !query) {
      performSearch('');
    } else if (suggestions.length > 0) {
      setIsOpen(true);
    }
  }, [suggestions, query, performSearch]);

  var addTag = useCallback(function(tagName) {
    var name = tagName.trim();
    if (!name || tagList.includes(name)) return;
    updateField('tag_list', tagList.concat([name]));
    setQuery('');
    setSuggestions([]);
    setIsOpen(false);
    scheduleAutosave();
  }, [tagList, updateField, scheduleAutosave]);

  var removeTag = useCallback(function(tagName) {
    updateField('tag_list', tagList.filter(function(t) { return t !== tagName; }));
    scheduleAutosave();
  }, [tagList, updateField, scheduleAutosave]);

  var handleKeyDown = useCallback(function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      addTag(query);
    }
  }, [query, addTag]);

  useEffect(function() {
    function handleClickOutside(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return function() { document.removeEventListener('mousedown', handleClickOutside); };
  }, []);

  useEffect(function() {
    return function() {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  return (
    <div className="tags-input" ref={containerRef}>
      {tagList.length > 0 && (
        <div className="tags-input__tags">
          {tagList.map(function(tag) {
            return (
              <span key={tag} className="tags-input__tag">
                {tag}
                <button type="button" className="tags-input__tag-remove" onClick={function() { removeTag(tag); }}>
                  <i className="zmdi zmdi-close" />
                </button>
              </span>
            );
          })}
        </div>
      )}
      <div className="form-group">
        <input type="text" className="form-control" placeholder={t.type_enter} value={query} onChange={handleInputChange} onKeyDown={handleKeyDown} onFocus={handleFocus} autoComplete="off" />
        <i className="form-group__bar" />
      </div>
      {isOpen && suggestions.length > 0 && (
        <div className="tags-input__suggestions">
          {suggestions.map(function(name, i) {
            return (<div key={name + i} className="tags-input__suggestion-item" onClick={function() { addTag(name); }}>{name}</div>);
          })}
        </div>
      )}
    </div>
  );
}
